import * as React from 'react'
import { Filter, FilterProps } from 'react-admin'
import { ClinicListFiltersArray } from './Filters'

const ClinicFilters: React.FC<Omit<FilterProps, 'children'>> = (props) => {
  return (
    <Filter {...props}>
      {ClinicListFiltersArray.map((item) => item.FilterInput)}
    </Filter>
  )
}

export default ClinicFilters
